import RtwProductType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  status: [
    {
      value: true,
      label: '販売中'
    },
    {
      value: false,
      label: '廃盤'
    }
  ]
}

const RtwProduct = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RtwProductType.GET_RTW_PRODUCT_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case RtwProductType.GET_DETAIL_RTW_PRODUCT_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case RtwProductType.PUT_RTW_PRODUCT_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case RtwProductType.POST_RTW_PRODUCT_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    default:
      return state
  }
}

export default RtwProduct
